import {roleFilter} from '../../services/common/options';
 
export default function getRights(moduleInfo){
    let neededInfo = roleFilter.filter(data => data.moduleName === moduleInfo);
    return(dispatch)=>{
        dispatch({
            type:"rights",
            payload:neededInfo[0]
        })
    }
}

export function updatedRights(info){
    return(dispatch)=>{
        dispatch({
            type:"updated_rights",
            payload: info.rights
        })
    }
}
 



// WEBPACK FOOTER //
// ./src/redux/action/rights.js